import { IconBackward } from '@consta/icons/IconBackward'
import { Button } from '@consta/uikit/Button'
import { Header } from '@library/components'
import type { FC } from 'react'
import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import type { RibbonItemsText } from '../types'
import css from './ProjectHeader.css'
import { ProjectName } from './ProjectName'
import { ProjectRightSideHeader } from './ProjectRightSideHeader'
import { RibbonPanel } from './ProjectToolbar'

type Props = {
  getActionFromRibbonItem: (arg: RibbonItemsText) => void
  selectedRibbonItem?: RibbonItemsText
  setSelectedRibbonItem: (arg: RibbonItemsText) => void
}

export const ProjectHeader: FC<Props> = ({
  getActionFromRibbonItem,
  selectedRibbonItem,
  setSelectedRibbonItem,
}) => {
  const contextMenuRef = useRef(null)
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate('/')
  }

  return (
    <>
      <Header className={css.projectHeader}>
        <Header.LeftBlock>
          <Button
            ref={contextMenuRef}
            size="s"
            view="clear"
            iconLeft={IconBackward}
            iconSize="s"
            onlyIcon={true}
            label="Вернуться к проектам"
            onClick={handleGoBack}
          />
        </Header.LeftBlock>
        <Header.Center>
          <ProjectName />
        </Header.Center>
        <Header.RightBlock>
          <ProjectRightSideHeader />
        </Header.RightBlock>
      </Header>

      <RibbonPanel
        getActionFromRibbonItem={getActionFromRibbonItem}
        selectedRibbonItem={selectedRibbonItem}
        setSelectedRibbonItem={setSelectedRibbonItem}
      />
    </>
  )
}
